<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Recover your password</h4>
                                    <p class="mb-3">Please enter your email address and we'll send you instructions on how to reset your password.</p>
                                    <vs-alert class="h-auto" v-if="message" :color="status ? 'success' : 'danger'" icon-pack="feather" icon="icon-info">
                                        <span> {{message}} </span>
                                    </vs-alert>
                                   
                                </div>


                                <div class="mb-8" v-if="!status">
                                    <vs-input v-validate="'required|email|min:3'" data-vv-validate-on="blur" name="email"
                                        icon-no-border icon="icon icon-user" icon-pack="feather" label-placeholder="Email"
                                        v-model="email" class="w-full" />
                                    <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                                </div>





                                <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Back To Login
                                </vs-button>
                                <vs-button v-if="!status" @click="forgetPassword" :disabled="!validateForm"
                                    class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0">Recover Password
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                email: '',
                message: '',
                status:''
            }
        },
        computed: {
            validateForm() {
                return !this.errors.any() && this.email !== ''
            }
        },
        methods: {
            forgetPassword() {
                this.$store.dispatch('auth/forget', this.email)
                    .then((response) => {
                        this.message = response.data.message
                        this.status = response.data.result
                        this.$vs.notify({
                            title: response.data.result ? 'Success' : 'Failed',
                            text: response.data.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: response.data.result ? 'success' : 'danger'
                        })
                        this.$vs.loading.close()
                    })
                    .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    })
            }
        }
    }
</script>